import { memo } from 'react';

function CircleIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			className="lucide lucide-circle"
			viewBox="0 0 24 24"
			{...props}
		>
			<circle cx="12" cy="12" r="10"></circle>
		</svg>
	);
}

export default memo(CircleIcon);
